module.exports = __webpack_public_path__ + "img/Skirt-Back-B1-Da-Fb-Ga-Hc 后背.181f2a50.png";